import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Row, Col } from 'fluid-react';
import Snackbar from 'material-ui/Snackbar';
import { Link } from 'react-router';
//import withWidth, {LARGE, SMALL} from 'material-ui/utils/withWidth';
/* import globalStyles from '../../../styles'; */
import axios from 'axios';
import urlBase from '../../../url-base';
import { FaStepBackward } from "react-icons/fa";
/* import ReactPaginate from 'react-paginate'; */

const availWidth = window.screen.availWidth;

class Intranet extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            countLeads: 0,
            countAwaitingSolution: 0,
            countWaitingConfirmation: 0,
            countAwaitingAfterSale: 0,
            countImplantedContracts: 0,
            countCanceledContracts: 0,
            countMaterials: 0,
            countNews: 0,
            countPending: 0,

            showPanelPF: true,
            showLeads: true,
            showAwaitingSolution: true,
            showWaitingConfirmation: true,
            showAwaitingAfterSale: true,
            showImplantedContracts: true,
            showCanceledContracts: true,
            showMaterials: true,
            showNews: true,
            showPending: true,

            showPanelPJ: true,
            showPJawaitingPayment: true,
            countPJawaitingPayment: 0,
            showPJonActivation: true,
            countPJonActivation: 0,
            showPJactivated: true,
            countPJactivated: 0,
            showPJinValidation: true,
            countPJinValidation: 0,
            showPJafterSales: true,
            countPJafterSales: 0,
            showPJpending: true,
            countPJpending: 0,
            showPJdeployed60Days: true,
            countPJdeployed60Days: 0,
            showPJcanceled60Days: true,
            countPJcanceled60Days: 0,

            snackbar: {
                open: false,
                msg: ''
            }
        };

        this.styles = {
            containerIcon: {
                paddingTop: 0,
                paddingBottom: 0
            },
            containerText: {
                paddingLeft: 0,
                height: 85,
            },
            containerTextDownload: {
                textAlign: 'center'
            },
            iconOrange: {
                backgroundColor: 'rgba(245, 170, 0, 0.72)',
                height: 85,
                textAlign: 'center',
                paddingTop: 12
            },
            iconRed: {
                backgroundColor: 'rgba(209, 4, 36, 0.62)',
                height: 85,
                textAlign: 'center',
                paddingTop: 25
            },
            iconBlue: {
                backgroundColor: 'rgba(2, 17, 199, 0.48)',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconGreen: {
                backgroundColor: 'rgba(5, 134, 15, 0.58)',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconDarkCyan: {
                backgroundColor: 'rgba(0,139,139,0.67)',
                height: 85,
                textAlign: 'center',
                paddingTop: 23
            },
            iconDimGray: {
                backgroundColor: 'rgba(105,105,105, 0.58)',
                height: 85,
                textAlign: 'center',
                paddingTop: 12
            },
            iconPurple: {
                backgroundColor: '#b778c7',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconBlueMega: {
                backgroundColor: '#809AE0',
                height: 85,
                textAlign: 'center',
                paddingTop: 17
            },
            iconGreenCarta: {
                backgroundColor: '#63D88B',
                height: 85,
                textAlign: 'center',
                paddingTop: 14
            },
            h1: {
                fontSize: availWidth < 500 ? 12 : 16,
                fontWeight: 100,
                paddingRight: 12,
                marginTop: 17,
                fontFamily: 'RubikRegular',
                color: "#757575",
                paddingLeft: 15,
            },
            hr: {
                height: '1px',
                backgroundColor: '#d1d1d1',
                textAlign: 'center',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '40px',
            },
            hh1: {
                fontSize: availWidth < 500 ? 12 : 16,
                fontWeight: 100,
                paddingRight: 12,
                marginTop: 2,
                fontFamily: 'RubikRegular',
                color: "#757575",
                paddingLeft: 15,
            },
            h1Download: {
                width: 'auto',
                paddingLeft: 10,
                paddingRight: 10,
                fontSize: 14,
                fontWeight: 100,
            },
            paper: {
                width: 'auto',
                marginLeft: 20,
                marginRight: 20,

            },
            backgroundPaper: {
                backgroundColor: "#ffffff",
                height: 85,
            },
            pagamento: {
                width: 65,
                height: 35,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/pagamento.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            pendentes: {
                width: 50,
                height: 50.,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/pendentes.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            propostas: {
                width: 55,
                height: 50,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/propostas.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            posvenda: {
                width: 65,
                height: 38,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/pos-venda.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            implantados: {
                width: 50,
                height: 60,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/contratos-implantados.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            cancelados: {
                width: 50,
                height: 60.,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/contratos-cancelados.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            interessados: {
                width: 50,
                height: 50,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/interessados.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            divulgacao: {
                width: 50,
                height: 50,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/divulgacao.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
            },
            novidades: {
                width: 50,
                height: 60,
                backgroundImage: 'url(' + require('../../../assets/images2/icons/novidades.png') + ')',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: '-2px'
            },
            p: {
                marginTop: 5,
                paddingTop: 9,
                fontSize: 20,
                fontWeight: 300,
                width: 50,
                height: 50,
                marginRight: 20,
                backgroundColor: "#f9f9f9",
                borderRadius: "100%",
                textAlign: "center",
                fontFamily: 'RubikMedium',
                color: "#757575",
            },
            tituloPagina2: {
                fontSize: availWidth < 500 ? 18 : 23,
                fontFamily: 'RubikMedium',
                width: '100%',
                color: "#757575",
                marginLeft: 'auto',
                marginRight: 'auto',
                paddingTop: 0,
                paddingBottom: 40,
                textAlign: "center",
            },
        };
    }


    componentDidMount() {
        let url = urlBase.loopBack + 'Sales/dataDashboard';
        let dataSubmit = {
            userId: localStorage.getItem('dental_u')
        };

        axios.post(url, dataSubmit)
            .then((response) => {
                let state = this.state;
                state.countLeads = response.data.leads;
                state.countAwaitingSolution = response.data.awaitingSolution;
                state.countWaitingConfirmation = response.data.waitingConfirmation;
                state.countAwaitingAfterSale = response.data.awaitingAfterSale;
                state.countImplantedContracts = response.data.implantedContracts;
                state.countCanceledContracts = response.data.canceledContracts;
                state.countMaterials = response.data.materials;
                state.countNews = response.data.news;
                state.countPending = response.data.pending;
                this.setState(state);
            })
            .catch(function () {
                alert('Problema ao buscar lista de quantidades');
            }.bind(this));

        // Busca quantidade para caixinhas do PJ
        this.getCountPj();

        // Verifica o perfil para exibição de caixas de resumo
        this.showBox();
    }

    getCountPj() {
        let url = urlBase.loopBack + 'Companies/countByUser';
        let dataSend = {
            user: localStorage.getItem('dental_u')
        };

        axios.post(url, dataSend)
            .then((response) => {
                let state = this.state;
                state.countPJawaitingPayment = response.data.countPJawaitingPayment;
                state.countPJonActivation = response.data.countPJonActivation;
                state.countPJactivated = response.data.countPJactivated;
                state.countPJinValidation = response.data.countPJinValidation;
                state.countPJafterSales = response.data.countPJafterSales;
                state.countPJpending = response.data.countPJpending;
                state.countPJdeployed60Days = response.data.countPJdeployed60Days;
                state.countPJcanceled60Days = response.data.countPJcanceled60Days;
                this.setState(state);
            })
            .catch(function () {
                alert('Problema ao buscar lista de quantidades');
            }.bind(this));
    }

    //fechar mensagem de bem vindo
    snackbarRequestClose() {
        let state = this.state;
        state.snackbar.open = false;
        state.snackbar.msg = '';
        this.setState(state);
    }

    showBox() {
        let state = this.state;
        let type = localStorage.getItem('dental_y');

        if (type == 'SALESMAN' || type == 'BROKER' || type == 'BACKOFFICE') {
            state.showLeads = false;
        }
        else if (type == 'REGISTER') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showPJawaitingPayment = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }
        else if (type == 'AFTER SALES') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showWaitingConfirmation = false;
            state.showPJawaitingPayment = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }
        else if (type == 'ADMIN') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showPanelPJ = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }
        else if (type == 'PJCADASTRO') {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showPJawaitingPayment = false;
            state.showPJawaitingPayment = false;
            state.showPanelPF = false;
        }
        else {
            state.showLeads = false;
            state.showAwaitingSolution = false;
            state.showWaitingConfirmation = false;
            state.showAwaitingAfterSale = false;
            state.showImplantedContracts = false;
            state.showCanceledContracts = false;
            state.showMaterials = false;
            state.showNews = false;
            state.showPending = false;
            state.showPanelPJ = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        }

        this.setState(state);
    }

    goBack() {
        window.history.back();
    }

    render() {
        return (
            <div id="resume_content">
                <style>{`
          #resume_content a {
            color: inherit;
          }
          #resume_content a:hover {
            text-decoration: none;
          }
        `}</style>

                <Snackbar
                    anchorOrigin={{ vertical: 'center', horizontal: 'top' }}
                    open={this.state.snackbar.open}
                    message={this.state.snackbar.msg}
                    autoHideDuration={4000}
                    onRequestClose={this.snackbarRequestClose.bind(this)}
                />

                <Row>
                    <Col xs="12" sm="12" md="3" lg="3" xl="3">
                        <p onClick={this.goBack.bind(this)} style={{ cursor: 'pointer' }}> <FaStepBackward />  Voltar</p>
                    </Col>
                    <Col xs="12" sm="12" md="3" lg="3" xl="3">
                    </Col>

                    <Col xs="12" sm="12" md="3" lg="3" xl="3">

                    </Col>
                </Row>

        
                <div style={this.styles.tituloPagina2}> PAINEL DE DOWNLOADS</div>
                {/******* MATERIAIS DE DIVULGAÇÃO */}
                <Grid container spacing={24} alignContent="center">
                    {
                        this.state.showMaterials ? (
                            <Grid item xs={12} sm={12} md={6} lg={6} style={{ marginBottom: 0 }}>
                                <Link
                                    to={urlBase.client + 'panel/promotionalmaterials'}
                                >
                                    <div style={this.styles.backgroundPaper}>
                                        <Grid container spacing={24} alignContent="center">
                                            <Grid item xs={4} sm={3} md={3} lg={3}
                                                style={this.styles.containerIcon}>
                                                <div style={this.styles.iconBlueMega}>
                                                    <div style={this.styles.divulgacao}>{""}</div>
                                                </div>
                                            </Grid>
                                            <Grid item xs={8} sm={9} md={9} lg={9}
                                                style={this.styles.containerText}>
                                                <Row>
                                                    <Col xs={9} sm={9} md={9} lg={9}>
                                                        {
                                                            localStorage.getItem('dental_y') == 'ADMIN' ? (
                                                                <div style={this.styles.hh1}>INSERIR MATERIAIS DE DIVULGAÇÃO</div>
                                                            ) : (
                                                                    <div style={this.styles.hh1}>BAIXE SEUS MATERIAIS DE DIVULGAÇÃO</div>
                                                                )
                                                        }
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Link>
                            </Grid>
                        ) : ('')
                    }
                    {/******* NOVIDADES DA DENTAL */}
                    {
                        this.state.showNews == true ? (
                            <Grid item xs={12} sm={12} md={6} lg={6} style={{ marginBottom: 0 }}>
                                <Link
                                    to={urlBase.client + 'panel/dentalnews'}
                                >
                                    <div style={this.styles.backgroundPaper}>
                                        <Grid container spacing={24} alignContent="center">
                                            <Grid item xs={4} sm={3} md={3} lg={3}
                                                style={this.styles.containerIcon}>
                                                <div style={this.styles.iconGreenCarta}>
                                                    <div style={this.styles.novidades}>{""}</div>
                                                </div>
                                            </Grid>
                                            <Grid item xs={8} sm={9} md={9} lg={9}
                                                style={this.styles.containerText}>
                                                <Row>
                                                    <Col xs={9} sm={9} md={9} lg={9}>
                                                        {
                                                            localStorage.getItem('dental_y') == 'ADMIN' ? (
                                                                <div style={this.styles.h1}>INSERIR NOVIDADES DA DENTAL</div>
                                                            ) : (
                                                                    <div style={this.styles.h1}>NOVIDADES DA DENTAL</div>
                                                                )
                                                        }
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Link>
                            </Grid>
                        ) : ('')
                    }
                </Grid>

            </div>
        );

    }

}


export default Intranet;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/ResumeNew/Intranet.js
 **/